import {ImageBackgroundType, ImageConfig, ProductImage} from '../types/images';

interface Parameters {
  [key: string]: string | number | boolean;
}

const PRODUCT_IMAGE_WIDTH_TO_HEIGHT_RATIO = 1.333;

function sortObjectProperties<T = {[key: string]: unknown}>(
  unsorted: T,
  order: Array<keyof T>,
): T {
  const sorted: T = {} as T;
  order.forEach(key => {
    if (unsorted[key]) {
      sorted[key] = unsorted[key];
      delete unsorted[key];
    }
  });
  return {
    ...sorted,
    ...unsorted,
  };
}

function stringifyParams(params: Parameters) {
  return Object.keys(params)
    .map(key => key + '=' + params[key])
    .join('&');
}

function cdnImageUrl(hash: string, queryParams: Parameters = {}): string {
  const cdnUrl = `https://cdn.aboutstatic.com/file/${hash}`;
  const stringifiedParams = stringifyParams(
    sortObjectProperties(queryParams, [
      'bg',
      'brightness',
      'quality',
      'trim',
      'height',
      'width',
    ]),
  );

  return `${cdnUrl}?${stringifiedParams}`;
}

function getBg(background: ImageBackgroundType): string | undefined {
  switch (background) {
    case 'transparent':
    case 'grey':
      return 'F4F4F5';
    default:
      return undefined;
  }
}

function getBrightness(background: ImageBackgroundType): number | undefined {
  if (background === 'white') {
    return 0.96;
  }

  return undefined;
}

function getTrim(
  imageType: ProductImage['type'],
  imageFocusType: ProductImage['focus'],
  background: ImageBackgroundType,
): boolean {
  if (
    imageType !== 'model' &&
    background !== 'grey' &&
    imageFocusType !== 'detail'
  ) {
    return true;
  }

  return false;
}

export const getCdnProductImageUrl = (
  image: ProductImage,
  config: ImageConfig,
): string => {
  const bg = getBg(image.background);
  const brightness = getBrightness(image.background);
  const trim = getTrim(image.type, image.focus, image.background);
  const options: Parameters = {
    quality: 75,
    width: config.width,
  };

  if (trim) {
    options.trim = '1';
    options.height = Math.ceil(
      Number(config.width) * PRODUCT_IMAGE_WIDTH_TO_HEIGHT_RATIO,
    );
  }

  if (bg) {
    options.bg = bg;
  }
  if (brightness) {
    options.brightness = brightness;
  }

  return cdnImageUrl(image.hash, options);
};
